const getSessionToken = () => {
    const token = localStorage.getItem('token');
    if (token === null) return null;
    try {
        return JSON.parse(token);
    } catch (error) {
        return null;
    }
};

const isLoggedIn = () => {
    const token = getSessionToken();
    return token !== null && token !== '';
};

const setSessionToken = (token) => {
    localStorage.setItem('token', JSON.stringify(token));
};

const setUser = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
};

const removeSessionToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

const redirectIfSessionExpired = (err, navigate) => {
    if (!err) return;

    const status = err.status;
    if (status && status === 'Token is Expired') {
        removeSessionToken();
        navigate('/auth/login');
    }
};

const getUser = () => {
    const userString = localStorage.getItem('user');
    if (!userString) return null;

    try {
        return JSON.parse(userString);
    } catch (error) {
        return null;
    }
};

export const Auth = {
    isLoggedIn,
    getSessionToken,
    setSessionToken,
    removeSessionToken,
    redirectIfSessionExpired,
    getUser,
    setUser
};